import { TrackingRecordSource } from './types';

export const sourceOptions: { label: string; value: TrackingRecordSource }[] = [
  { label: 'Ingrid TMS', value: 'TRACKING_RECORD_SOURCE_INTERNAL' },
  { label: 'External', value: 'TRACKING_RECORD_SOURCE_EXTERNAL' },
  { label: 'Unknown', value: 'TRACKING_RECORD_SOURCE_UNKNOWN' },
];
